import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	tabHeaderRoot: {
		borderWidth: '0.125rem',
		borderColor: theme.palette.neutral.n200,
		borderStyle: 'solid',
		borderLeftWidth: 0,
		borderRightWidth: 0,
		background: theme.palette.neutral.n100,
		padding: theme.spacing(2),
	},
	title: { margin: '1rem 0' },
	explanation: {
		marginBottom: '1.25rem',
		maxWidth: '128ch',
	},
	actions: { marginBottom: '0.5rem' },
}));
export default function TabHeader({ title, titleDataCy, explanation, explanationDataCy, actions, actionsSpacing }) {
	const classes = useStyles();
	return (
		<Grid className={classes.tabHeaderRoot} container item direction="column">
			<Grid className={classes.title} item>
				<Typography variant="h5" data-cy={titleDataCy}>
					{title}
				</Typography>
			</Grid>
			<Grid className={classes.explanation} item>
				<Typography variant="body2" data-cy={explanationDataCy}>
					{explanation}
				</Typography>
			</Grid>
			<Grid
				className={classes.actions}
				container
				item
				alignItems="center"
				direction="row"
				spacing={actionsSpacing}
			>
				{actions
					? actions.map((action, index) => (
							<Grid item key={index}>
								{action}
							</Grid>
					  ))
					: null}
			</Grid>
		</Grid>
	);
}

TabHeader.propTypes = {
	title: PropTypes.string.isRequired,
	titleDataCy: PropTypes.string,
	explanation: PropTypes.string.isRequired,
	explanationDataCy: PropTypes.string,
	actions: PropTypes.arrayOf(PropTypes.element),
	actionsSpacing: PropTypes.number,
};
TabHeader.defaultProps = {
	title: '<title here>',
	explanation: '<explanation paragraph here>',
	actionsSpacing: 4,
};
